module.exports = __webpack_public_path__ + "static/media/play.345a29a0.svg";